import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

export function postAdvancedCommodityUpdate(_this, data, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "POST",
    endpoint: "analytics_commodity_update",
    content_type: "application/json",
    query_params: {
      format: "json",
      derivatives: JSON.stringify(data),
      expo: JSON.stringify(null)
    }
  };
  let dateFieldsHedge = [
    "asian_fixing_start_date",
    "created_at",
    "fixing_date",
    "hedged_date",
    "premium_value_date",
    "selected_contract",
    "trade_date",
    "updated_at",
    "value_date"
  ];
  return apiService
    .getAll(params)
    .then(response => {
      response = JSON.parse(JSON.stringify(response));
      response.forEach(function(d) {
        for (let i = 0; i < dateFieldsHedge.length; i++) {
          d[dateFieldsHedge[i]] = timeParseNull2(d[dateFieldsHedge[i]]);
        }
        d.cash_flow = 0;
        d.balance = 0;
      });
      response.forEach(function(d) {
        delete d.row;
      });
      Object.assign(_this.allDataRaw[0], {
        hedge: response
      });

      _this[fieldShowLoadingName] = false;
      _this.createExpoHedgeVariables();
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
